import React, { useState, useEffect, useRef } from "react";
import { Http } from "../../../../../helpers/axois";
import CodeEditor from "../../../../../helpers/CodeEditor2";
import { useParams, useHistory } from "react-router-dom";
import { AppState } from "../../../../../stateManager/store";
import { useSelector } from "react-redux";
import { useToast, redirectOnError, encodeBase64 } from "../../../../../helpers/commonFunction";
import { Button, Modal } from "../../../../../helpers/commonUi";
import style from './service.module.sass'
import ModalFooter from "../../../../../helpers/commonUi/ModalFooter";
import SplitPane, { Pane } from "../../../../../plugin/react-split-pane";
import { ReactComponent as JavaScript } from "../../../../../assets/svg/javascript.svg"
import { ReactComponent as TypeScript } from "../../../../../assets/svg/typescript.svg"
import { ReactComponent as A8Logo } from "../../../../../assets/svg/a8_logo_poweredby.svg"
import { ReactComponent as GoBack } from "../../../../../assets/svg/goback.svg"
import { ReactComponent as Logo } from "../../../../../assets/svg/signIn_logos/uniphore-color.svg"
import { Tooltip } from "antd";
import TarsIcon from "../../../../../assets/images/tarsIcon.png"
import TarsChatBot from "../../../Assisted/forms/create/properties/TarsChatBot";
// import VulnerabilitiesDrawer from "../../../common/vulnerabilityModel";
// import vulnerabilitiesImg from "../../../../../assets/images/vulnerabilities.svg"


export default function Create() {
  // const [showVulnerabilityModal, setShowVulnerabilityModal] = useState(false)
  // const [vulnerabilityReport, setVulnerabilityReport] = useState<{line: number, ruleId: string, message: string}[]>([])
  const [source, setSource] = useState<string>("");
  const [lang, setLang] = useState<any>();
  const params: any = useParams();
  const history: any = useHistory();
  const appId = params.appId;
  const serviceId = params.serviceId;
  const [soloServiceData, setSoloServiceData] = useState<any>();
  const [resourceLock, setResourceLock] = useState<any>({});
  const [checkoutVisible, setCheckoutVisible] = useState<boolean>(false)
  const [commitVisible, setCommitVisible] = useState<boolean>(false);
  const [isCommit, setIsCommit] = useState(false);

  const appversion: { currentVersion: boolean; versionId: string } = useSelector((state: AppState) => state.apps.appVersion[appId]);
  const currentVersion = appversion && appversion.currentVersion;
  const { ErrorToast, SuccessToast, WarningToast } = useToast();
  const editorRef: any = useRef(null)
  
  const loggedInUserId = useSelector((state: any) => {
    return state.user.data.user.id
  })
  const isCheckedIn: boolean = resourceLock === loggedInUserId

  const currentBranch: any = useSelector((state: any) => {
    const selectedAppId = state.apps.selectedApp && state.apps.selectedApp.id
    return (state.apps.appBranch && state.apps.appBranch[selectedAppId]) || {}
  }, (left: any, right: any) => left.branchId === right.branchId)

  const { selectedService } = useSelector((state: any) => state.solo)
  const orgPermissions: any = useSelector((state: any) => {
    return state.org.orgPermissions
  }, (oldPermissions: any, newPermissions: any) => JSON.stringify(oldPermissions) === JSON.stringify(newPermissions))

  const appPermissions: any = useSelector((state: any) => {
    return state.apps.selectedApp.permissions
  }, (oldPermissions: any, newPermissions: any) => JSON.stringify(oldPermissions) === JSON.stringify(newPermissions))

  // const orgId: any = useSelector((state: any) => {
  //   return state.org.selectedOrg.id
  // })

  const canEditService = currentVersion && (orgPermissions.includes('service.Edit') || appPermissions.includes('service.Edit'))
  const canForceReleaseService = orgPermissions.includes('service.ForceReleaseLock') || appPermissions.includes('service.ForceReleaseLock')

  // useEffect(() => {
  //   if((typeof resourceLock.userId !== 'undefined') && (!canEditService || !isCheckedIn)) {
  //     let message: string = ''
  //     if(!currentVersion) {
  //       message = ''
  //     }
  //     WarningToast('Editor is in read-only mode. No authorization to edit this service')
  //   }
  // }, [canEditService, WarningToast, resourceLock.userId, isCheckedIn])

  const value: string =
    `async function main(params) {
      // All deletions and soft deletions happen at the end of code execution
      // start of editable area

      // @description Description
      // @param {string} param1
      // @param {integer?} param2
      // @additionalParams false
      
      // end of editable area   
 }`;

  const getResourceLockData = async () => {
    if (appversion && appversion.versionId) {
      const branchId = currentBranch && currentBranch.branchId
      const versionId = appversion.versionId;
      const data: any = await Http.get(`/apps/${appId}/solo-services/${serviceId}?versionId=${versionId}&branchId=${branchId}`).toPromise()
      if (data) {
        return data?.resourceLock
      }
    }
  }

  const getSoloService = React.useCallback((discard?: boolean) => {
    if (appversion && appversion.versionId && selectedService === "solo") {
      const versionId = appversion.versionId;
      const navigateTo = `/apps/list/${appId}/solo/service/list`
      Http.get(`/apps/${appId}/solo-services/${serviceId}?versionId=${versionId}`).subscribe((soloServiceRes: any) => {
        if (soloServiceRes) {
          setLang(soloServiceRes.language);
          setSoloServiceData(soloServiceRes);
          setResourceLock(soloServiceRes?.resourceLock?.userId)
          // setVulnerabilityReport(soloServiceRes?.vulnerabilityScan?.report?.issues)
          if (soloServiceRes.source) {
            const values = soloServiceRes.source;
            if (values) {
              setSource(values);
              if (editorRef.current && discard) {
                editorRef.current.setValue(values)
              }
            }
          } else if(editorRef.current && discard) {
              editorRef.current.setValue(value)
          }
        } else {
          redirectOnError(history, 'no data', navigateTo, "View all services", "serviceId");
        }
      }, (err) => {
        console.log({ err, history, navigateTo })
        redirectOnError(history, err.error, navigateTo, "View all services", "serviceId");
      })
    }

  }, [appId, appversion, serviceId, history, selectedService, source, editorRef])

  useEffect(() => {
    getSoloService();
  }, [getSoloService]);

  const onEditorSave = (editorValue: { source: string; comSource: string }, discard?: boolean) => {
    const data = {
      name: soloServiceData.name,
      language: lang,
      source: encodeBase64(editorValue.source),
      compiledSource: encodeBase64(editorValue.comSource),
      branchId: currentBranch && currentBranch.branchId,
      versionId: appversion.versionId,
    };
    Http.put(`/apps/${appId}/solo-services/${soloServiceData.id}${isCommit && `?isCommit=true` || ``}${discard ? "&discard=true":""}`, data).subscribe(
      (res) => {
        if (isCommit) {
          SuccessToast('Service committed successfully')
          setCommitVisible(false)
          getSoloService(discard)
        } else {
          SuccessToast('Solo service saved successfully')
        }
      },
      (err) => {
        if (isCommit) {
          ErrorToast(`Error committing service${err.message ? `: ${err.message}` : ""}`)
        } else {
          ErrorToast(`Error saving  solo service${err.message ? `: ${err.message}` : ""}`)
        }
      }
    );
    setIsCommit(false)
  };



  const onClickCheckout = async () => {
    const lockData: any = await getResourceLockData()
    if (lockData?.userId === loggedInUserId) {
      WarningToast('You have already checkout out this resource!')
      getSoloService()
    } else {
      setResourceLock(lockData)
      setCheckoutVisible(true)
    }
  }

  const onClickCommit = async () => {
    const lockData: any = await getResourceLockData()
    if (!lockData?.userId) {
      ErrorToast('No one has checked out this resource. Commit Failed!')
      getSoloService()
      setIsCommit(false)
    } else if (lockData?.userId === loggedInUserId) {
      setCommitVisible(true)
      setIsCommit(true)
    } else {
      ErrorToast(`${lockData?.userName} has checkout out this resource. Commit Failed!`)
      setIsCommit(false)
      getSoloService()
    }
  }

  const onClickSave = async () => {
    const lockData: any = await getResourceLockData();
    if (!lockData?.userId) {
      ErrorToast('No one has checked out this resource. Save Failed!')
      getSoloService()
    } else if (lockData?.userId === loggedInUserId) {
      let modalId: number = 7238210;
      let event = new KeyboardEvent("keydown", {
        key: "s",
        code: "KeyS",
        ctrlKey: true,
        detail: modalId,
      });
      document.dispatchEvent(event);
    } else {
      ErrorToast(`${lockData.userName} has checkout out this resource. Save Failed!`)
      getSoloService()
    }
  }

  const checkout = () => {
    const versionId = appversion.versionId;
    Http.post(`apps/${appId}/solo-services/${serviceId}/checkout`, {
      appId,
      versionId: versionId
    }).subscribe(() => {
      SuccessToast(`Service checked out`)
      setCheckoutVisible(false)
      getSoloService()
    }, (err) => {
      ErrorToast(`Error checking out service${err.message ? `: ${err.message}` : ""}`)
    })
  }

  const commit = () => {
    let modalId: number = 7238210;
    let event = new KeyboardEvent("keydown", {
      key: "s",
      code: "KeyS",
      ctrlKey: true,
      detail: modalId,
    });
    document.dispatchEvent(event);
  }

  const discard = () => {
    let modalId: number = 7238212;
    let event = new KeyboardEvent("keydown", {
      key: "s",
      code: "KeyS",
      ctrlKey: true,
      detail: modalId,
    });
    document.dispatchEvent(event);
  }

  const forceRelease = () => {
    Http.post(`apps/${appId}/solo-services/${serviceId}/force-release`, {
      appId,
      versionId: appversion.versionId
    }).subscribe((res) => {
      SuccessToast(`Service force released successfully`)
      getSoloService()
      setCheckoutVisible(false)
    }, (err) => {
      ErrorToast(`Error force releasing service${err.message ? `: ${err.message}` : ""}`)
    })
  }
  const [isVisibleTars, setIsVisibleTars] = useState(true);
  const [currentLine, setCurrentLine] = useState(3);

  return (
    <div className="viewWrapper" style={{padding:"0px",height:"100vh"}}>
      <SplitPane className={""} paneStyle={{ width: window.innerWidth + "px" }} >
        <Pane className={' override-component-pane'} minSize={!isVisibleTars ? "100%" : "40%"} initialSize={!isVisibleTars ? "100%" : "60%"} maxSize={!isVisibleTars ? "100%" : "80%"}>
          <div
            className="func_header"
            style={{
              fontSize: "16px",
              textTransform: "capitalize",
            }}
          >
            <div style={{ display: "flex", gap: "7px", alignItems: "center" }}>
              <GoBack onClick={(() => { history.goBack() })}/>
              <span className="func_name">{(soloServiceData && soloServiceData.name)}</span>
              {
                lang === "javascript" ? <JavaScript></JavaScript> : <TypeScript></TypeScript>
              }
            </div>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                height: "50px",
              }}
            >
              {
                ((isCheckedIn && canEditService)) && (
                  <>
                    {<div>
                      <button className="func_btn_cmt" onClick={onClickCommit}>
                        COMMIT
                      </button>
                    </div>}
                    <div style={{ marginLeft: '12px' }}>
                      <button className="func_btn_sve tour_service_save" onClick={onClickSave}>
                        SAVE
                      </button>
                    </div>
                  </>
                )
              }
              {/* {vulnerabilityReport?.length > 0 && <div>
                <div className={style.vulnerability} style={{marginRight: 10}} onClick={(e) => {
                  e.stopPropagation();
                  setShowVulnerabilityModal(true)
                }}>
                  <img src={vulnerabilitiesImg} alt="vulnerabilities" style={{ height: 20, width: 20 }} />
                  <span className={style.vulnerabilitiesText}>{`vulnerabilities (${vulnerabilityReport?.length})`}</span>
                </div>
              </div>} */}
              {!isVisibleTars && <Tooltip placement="bottom" title={"TARS"} trigger={'hover'}>
                <div style={{ display: "flex", alignItems: "center", marginLeft: "12px", height: "40px", borderRadius: "5px", cursor: "pointer" }} onClick={(() => { setIsVisibleTars(true) })}>
                  <img style={{ height: "33px", width: "33px", objectFit: "contain" }} src={TarsIcon} alt="tars_icon"></img>
                </div>
              </Tooltip>}
              {
                !isCheckedIn && canEditService && (
                  <div style={{ marginLeft: '12px' }}>
                    <button className="func_btn_checkout tour_service_checkout" onClick={onClickCheckout}>CHECKOUT</button>
                  </div>
                )
              }
            </div>
          </div>

          <div>
            <CodeEditor
              data-test-id="service_code_editor"
              minimap={false}
              value={source ? source : value}
              height="calc(100vh - 180px)"
              lang={lang}
              type={"service"}
              fontSize={16}
              onSave={(canEditService && isCheckedIn) ? onEditorSave : null}
              readOnly={!(isCheckedIn)}
              theme="light"
              editorRef={editorRef}
            />
          </div>
          <div style={{ width: "100%", height: "70px", display: "flex", alignItems: "center", paddingLeft: "10px", borderTop: "1px solid #D9D9D9" }}>
              {/* <A8Logo /> */}
            <p style={{ marginBottom: 0, paddingRight: 10 }}>Powered By</p>
            <Logo />
          </div>
        </Pane>
        {isVisibleTars &&
          <Pane className={' override-component-pane tour_tars_chat_panel'} minSize="30%" initialSize="40%" maxSize="60%">
            <TarsChatBot editorRef={editorRef} type={"serviceTask"} currentLine={currentLine} setIsVisibleTars={setIsVisibleTars} ></TarsChatBot>
          </Pane>
        }
      </SplitPane>

      {/* <VulnerabilitiesDrawer isOpen={showVulnerabilityModal} onClose={() => setShowVulnerabilityModal(false)} vulnerabilities={vulnerabilityReport} /> */}
      <Modal
        id='checkoutModal'
        dataTestId='checkoutModal'
        title={!resourceLock?.userId ? "CHECKOUT" : "WARNING"}
        visible={checkoutVisible}
        onCancel={() => {
          setCheckoutVisible(false)
        }}
        unmountOnCancel={true}
        footer={{
          enable: true,
          okText: !resourceLock?.userId ? "CHECKOUT" : canForceReleaseService ? "FORCE RELEASE" : "OK",
          cancelText: "CANCEL",
          onOk: () => {
            if (!resourceLock?.userId) {
              checkout()
            } else if (canForceReleaseService) {
              forceRelease()
            } else {
              setCheckoutVisible(false)
            }
          }
        }}
      >
        {
          !resourceLock?.userId ?
            <>
              <div className={style.modalMsg}>
                Do you want to checkout ?
              </div>
              <div className={style.note}>
                Note: This will prevent others from editing this resource until you commit
              </div>
            </>
            :
            <>
              <div className={style.modalMsg}>
                <span className={style.modalHighlightedMsg}>{resourceLock.userName}</span> has currently checked out this resource
              </div>
              {
                canForceReleaseService &&
                <>
                  <div className={style.modalMsg}>
                    Do you want to force release ?
                  </div>
                  <div className={style.note}>
                    Note: This will revoke editing access from the currently checked out user.
                  </div>
                </>
              }
            </>
        }
      </Modal>
      <Modal
        id='commitModal'
        dataTestId='commitModal'
        title="COMMIT"
        visible={commitVisible}
        onCancel={() => {
          setCommitVisible(false)
          setIsCommit(false)
        }}
        unmountOnCancel={true}
        footer={{
          enable: false,
        }}
      >
        {
          <>
            <div className={style.modalMsg}>
              Do you want to save or discard your work?
            </div>
            <ModalFooter
              okText="SAVE & COMMIT"
              cancelText="DISCARD & COMMIT"
              okCallback={commit}
              cancelCallback={discard}
              cancelClassName="discard_btn"
            />
          </>
        }
      </Modal>
    </div>
  );
};
